import React, { useState, useEffect } from "react";
import { useUser } from "../../context/UserContext";
import { Link } from "react-router-dom";
import { jobsEndpoint } from "../../constants";
import { IoCalendarClearOutline } from "react-icons/io5";
import { IoCloudDownloadOutline } from "react-icons/io5";
import {
  BasicColumnChartAverageTimeToFill,
  BasicColumnChartRecruiterWorkload,
} from  "../ContainerChart";
import ChartMiniGreen from "../../assets/ChartMiniGreen.svg";
import ChartMiniRed from "../../assets/ChartMiniRed.png";
import ChartMiniOrange from "../../assets/ChartMiniOrange.png";

const ManagerDashboard = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [stats, setStats] = useState({
    activeJobs: { count: 0, change: 0 },
    shortlisted: { count: 0, change: 0 },
    timeToHire: { days: 0, change: 0 },
  });
  const [pipelineData, setPipelineData] = useState([]);
  const [scheduledInterviews, setScheduledInterviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token");
  const { user } = useUser();

  const dropDiverseData = [
    {
      title: "Drop off rate",
      present: 24,
      average: 8.6,
      days: "30 days",
    },
    {
      title: "Diverse Candidate %",
      present: 24,
      average: 8.6,
      days: "30 days",
    },
    { title: "Drop off Stage", dropOffStage: "Interview" },
    {
      title: "AI Insight",
      AIinsight: "Job X has had no movement in 3 weeks",
    },
  ];

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await fetch(jobsEndpoint + "stats/", {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`,
          }
        });
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setStats({
          activeJobs: { count: data.active_jobs, change: 0 },
          shortlisted: { count: data.shortlisted_candidates, change: 0 },
          timeToHire: { days: data.avg_time_to_hire, change: 0 },
        });
        setPipelineData(data.pipeline_breakdown);
      } catch (error) {
        console.error("Failed to fetch job stats:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

    const [pipelineMockData, setPipelineMockData] = useState([
    { stage: "Applied", count: 1286, percentage: 85 },
    { stage: "Shortlisted", count: 864, percentage: 65 },
    { stage: "Interviews", count: 624, percentage: 45 },
    { stage: "Offer Sent", count: 246, percentage: 25 },
    { stage: "Hired", count: 124, percentage: 15 },
  ]);

  const StatCard = ({ title, count, change, trend, suffix = "" }) => (
    <div className="bg-white rounded-xl border border-gray-200 flex flex-col">
      <div className="bg-gray-50 py-3 px-5 rounded-t-xl">
        <h3 className="text-md font-semibold text-gray-900">{title}</h3>
      </div>
      <div className="flex items-center px-5 py-3 gap-8 border-t border-gray-200 rounded-md">
        <p className="text-3xl font-semibold text-gray-900">
          {typeof count === "number" ? count.toLocaleString() : count}{suffix}
        </p>
        <div className={`flex text-sm ${change >= 0 ? "text-emerald-600" : "text-red-600"}`}>
          <span>
            {change >= 0 ? "↑" : "↓"} {Math.abs(change)}%
          </span>
          <span className="text-gray-600 ml-1">vs last month</span>
        </div>
      </div>
      <div className="my-4 h-[60px] w-full">
        <svg className="w-full h-full" viewBox="0 0 200 60" fill="none">
          <path
            d={trend}
            stroke={change >= 0 ? "#19BFB7" : "#FF6B6B"}
            strokeWidth="2"
            fill="none"
          />
        </svg>
      </div>
    </div>
  );

  return (
    <div className="lg:p-6">
      <div className="flex justify-between items-center mb-8">
        <div>
          <h1 className="text-2xl font-semibold text-gray-900">
            Welcome back, {user ? user.first_name || user.username : 'Guest'}
          </h1>
          <p className="text-sm text-gray-500">
            Here is a complete overview of your system.
          </p>
        </div>


      </div>
{/* Statistics Cards */}
<div className="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 gap-6 mb-6">
  {/* Card 1: Active Job Openings */}
  <div className="min-w-[320px] flex justify-start items-start flex-col bg-[#FDFDFD] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
    <div className="flex self-stretch justify-start items-start flex-col gap-0.5">
      <div className="flex self-stretch justify-start items-center flex-row gap-4 pt-3 pb-2 px-[20px]">
        <p className="flex-1 text-[#181D27] text-sm font-semibold">
          Total Job Openings
        </p>
      </div>
      <div className="flex self-stretch justify-start items-start flex-col gap-5 p-[20px] bg-[#FFFFFF] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)] relative">
        <div className="flex flex-wrap self-stretch justify-start items-center flex-row gap-3">
          <span className="text-[#181D27] text-3xl font-semibold">
            2,420
          </span>
          <div className="flex justify-start items-center flex-row gap-2">
            <div className="flex justify-center items-center flex-row gap-1">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.6667 4.66602L9.42092 9.91177C9.15691 10.1758 9.02491 10.3078 8.87269 10.3572C8.73879 10.4008 8.59456 10.4008 8.46067 10.3572C8.30845 10.3078 8.17644 10.1758 7.91243 9.91177L6.08759 8.08693C5.82358 7.82292 5.69157 7.69091 5.53936 7.64145C5.40546 7.59795 5.26123 7.59795 5.12733 7.64145C4.97511 7.69091 4.84311 7.82292 4.5791 8.08693L1.33334 11.3327M14.6667 4.66602H10M14.6667 4.66602V9.33268"
                  stroke="#17B26A"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span className="text-[#079455] text-sm text-center font-medium">
                40%
              </span>
            </div>
            <span className="text-[#535862] text-sm font-medium">
              vs last month
            </span>
          </div>
        </div>

        <div>
          <img src={ChartMiniGreen} alt="" />
        </div>
        <div
          className="flex justify-start items-start flex-col absolute"
          style={{
            right: "20px",
            width: "20px",
            top: "20px",
            height: "20px",
          }}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 10.834C10.4603 10.834 10.8334 10.4609 10.8334 10.0007C10.8334 9.54041 10.4603 9.16732 10 9.16732C9.53978 9.16732 9.16669 9.54041 9.16669 10.0007C9.16669 10.4609 9.53978 10.834 10 10.834Z"
              stroke="#A4A7AE"
              strokeWidth="1.66667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10 5.00065C10.4603 5.00065 10.8334 4.62755 10.8334 4.16732C10.8334 3.70708 10.4603 3.33398 10 3.33398C9.53978 3.33398 9.16669 3.70708 9.16669 4.16732C9.16669 4.62755 9.53978 5.00065 10 5.00065Z"
              stroke="#A4A7AE"
              strokeWidth="1.66667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10 16.6673C10.4603 16.6673 10.8334 16.2942 10.8334 15.834C10.8334 15.3737 10.4603 15.0007 10 15.0007C9.53978 15.0007 9.16669 15.3737 9.16669 15.834C9.16669 16.2942 9.53978 16.6673 10 16.6673Z"
              stroke="#A4A7AE"
              strokeWidth="1.66667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>

  {/* Card 2: Total Applicants */}
  <div className="min-w-[320px] flex justify-start items-start flex-col bg-[#FDFDFD] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
    <div className="flex self-stretch justify-start items-start flex-col gap-0.5">
      <div className="flex self-stretch justify-start items-center flex-row gap-4 pt-3 pb-2 px-[20px]">
        <p className="flex-1 text-[#181D27] text-sm font-semibold">
         Candidate Engagement Score
        </p>
      </div>
      <div className="flex self-stretch justify-start items-start flex-col gap-5 p-[20px] bg-[#FFFFFF] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)] relative">
        <div className="flex flex-wrap self-stretch justify-start items-center flex-row gap-3">
          <span className="text-[#181D27] text-3xl font-semibold">
            1,210
          </span>
          <div className="flex justify-start items-center flex-row gap-2">
            <div className="flex justify-center items-center flex-row gap-1">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.6666 11.3327L9.42089 6.08693C9.15688 5.82292 9.02488 5.69091 8.87266 5.64145C8.73876 5.59795 8.59453 5.59795 8.46064 5.64145C8.30842 5.69091 8.17641 5.82292 7.9124 6.08693L6.08756 7.91177C5.82355 8.17578 5.69154 8.30779 5.53932 8.35724C5.40543 8.40075 5.2612 8.40075 5.1273 8.35724C4.97508 8.30779 4.84308 8.17578 4.57907 7.91177L1.33331 4.66602M14.6666 11.3327H9.99998M14.6666 11.3327V6.66602"
                  stroke="#F04438"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span className="text-[#D92D20] text-sm text-center font-medium">
                10%
              </span>
            </div>
            <span className="text-[#535862] text-sm font-medium">
              vs last month
            </span>
          </div>
        </div>

        <img src={ChartMiniRed} alt="" />
        <div
          className="flex justify-start items-start flex-col absolute"
          style={{
            right: "20px",
            width: "20px",
            top: "20px",
            height: "20px",
          }}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 10.834C10.4603 10.834 10.8334 10.4609 10.8334 10.0007C10.8334 9.54041 10.4603 9.16732 10 9.16732C9.53978 9.16732 9.16669 9.54041 9.16669 10.0007C9.16669 10.4609 9.53978 10.834 10 10.834Z"
              stroke="#A4A7AE"
              strokeWidth="1.66667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10 5.00065C10.4603 5.00065 10.8334 4.62755 10.8334 4.16732C10.8334 3.70708 10.4603 3.33398 10 3.33398C9.53978 3.33398 9.16669 3.70708 9.16669 4.16732C9.16669 4.62755 9.53978 5.00065 10 5.00065Z"
              stroke="#A4A7AE"
              strokeWidth="1.66667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10 16.6673C10.4603 16.6673 10.8334 16.2942 10.8334 15.834C10.8334 15.3737 10.4603 15.0007 10 15.0007C9.53978 15.0007 9.16669 15.3737 9.16669 15.834C9.16669 16.2942 9.53978 16.6673 10 16.6673Z"
              stroke="#A4A7AE"
              strokeWidth="1.66667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>

  {/* Card 3: Average Time to Hire */}
  <div className="min-w-[320px] flex justify-start items-start flex-col bg-[#FDFDFD] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
    <div className="flex self-stretch justify-start items-start flex-col gap-0.5">
      <div className="flex self-stretch justify-start items-center flex-row gap-4 pt-3 pb-2 px-[20px]">
        <p className="flex-1 text-[#181D27] text-sm font-semibold">
         Offer Acceptance Rate
        </p>
      </div>
      <div className="flex self-stretch justify-start items-start flex-col gap-5 p-[20px] bg-[#FFFFFF] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)] relative">
        <div className="flex flex-wrap self-stretch justify-start items-center flex-row gap-3">
          <span className="text-[#181D27] text-3xl font-semibold">
            2 Weeks
          </span>
          <div className="flex justify-start items-center flex-row gap-2">
            <div className="flex justify-center items-center flex-row gap-1">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.6667 4.66602L9.42095 9.91177C9.15694 10.1758 9.02494 10.3078 8.87272 10.3572C8.73882 10.4008 8.59459 10.4008 8.4607 10.3572C8.30848 10.3078 8.17647 10.1758 7.91246 9.91177L6.08762 8.08693C5.82361 7.82292 5.6916 7.69091 5.53939 7.64145C5.40549 7.59795 5.26126 7.59795 5.12736 7.64145C4.97514 7.69091 4.84314 7.82292 4.57913 8.08693L1.33337 11.3327M14.6667 4.66602H10M14.6667 4.66602V9.33268"
                  stroke="#17B26A"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span className="text-[#079455] text-sm text-center font-medium">
                20%
              </span>
            </div>
            <span className="text-[#535862] text-sm font-medium">
              vs last month
            </span>
          </div>
        </div>

        <div>
          <img src={ChartMiniOrange} alt="" />
        </div>
        <div
          className="flex justify-start items-start flex-col absolute"
          style={{
            right: "20px",
            width: "20px",
            top: "20px",
            height: "20px",
          }}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.99996 10.834C10.4602 10.834 10.8333 10.4609 10.8333 10.0007C10.8333 9.54041 10.4602 9.16732 9.99996 9.16732C9.53972 9.16732 9.16663 9.54041 9.16663 10.0007C9.16663 10.4609 9.53972 10.834 9.99996 10.834Z"
              stroke="#A4A7AE"
              strokeWidth="1.66667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9.99996 5.00065C10.4602 5.00065 10.8333 4.62755 10.8333 4.16732C10.8333 3.70708 10.4602 3.33398 9.99996 3.33398C9.53972 3.33398 9.16663 3.70708 9.16663 4.16732C9.16663 4.62755 9.53972 5.00065 9.99996 5.00065Z"
              stroke="#A4A7AE"
              strokeWidth="1.66667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9.99996 16.6673C10.4602 16.6673 10.8333 16.2942 10.8333 15.834C10.8333 15.3737 10.4602 15.0007 9.99996 15.0007C9.53972 15.0007 9.16663 15.3737 9.16663 15.834C9.16663 16.2942 9.53972 16.6673 9.99996 16.6673Z"
              stroke="#A4A7AE"
              strokeWidth="1.66667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
</div>
     
      

      {/* Charts */}
      <div className="grid grid-cols-2 gap-6 w-full mb-6">
        <div className="gap-6">
          <div className="bg-gray-50 rounded-xl border border-gray-200">
            <div className="bg-gray-50 py-3 px-5 rounded-t-xl">
              <h3 className="text-lg font-semibold text-gray-900">
                Recruiter Workload
              </h3>
            </div>
            <div className="w-full flex items-center gap-3 rounded-xl border border-gray-200 bg-white">
              <BasicColumnChartRecruiterWorkload />
            </div>
          </div>
        </div>
        <div className="gap-6">
          <div className="bg-gray-50 rounded-xl border border-gray-200">
            <div className="bg-gray-50 py-3 px-5 rounded-t-xl">
              <h3 className="text-lg font-semibold text-gray-900">
                Average Time-to-Fill
              </h3>
            </div>
            <div className="w-full flex items-center gap-3 rounded-xl border border-gray-200 bg-white">
              <BasicColumnChartAverageTimeToFill />
            </div>
          </div>
        </div>
      </div>

      {/* Hiring Pipeline & Scheduled Interviews */}
      <div className="w-full gap-6">
        <div className="bg-white rounded-xl border border-gray-200">
          <div className="bg-gray-50 py-3 px-5 rounded-xl">
            <h3 className="text-lg font-semibold text-gray-900">
              Hiring Pipeline Breakdown
            </h3>
          </div>
          <div className="w-full grid md:grid-cols-3 gap-3 bg-gray-50">
            <div className="h-96 grid col-span-2 grid-cols-5 gap-3 py-3 px-5 border rounded-xl border-gray-200 bg-white">
              {loading ? (
                <p>Loading...</p>
              ) : (
                pipelineMockData.map((stage, index) => (
                  <div
                    key={stage.stage}
                    className="border flex flex-col gap-4 justify-between rounded-md border-gray-200 p-2"
                  >
                    <div className="flex flex-col gap-2 text-sm mb-1">
                      <p className="text-gray-600 text-md font-semibold">
                        Step {index + 1}
                      </p>
                      <h3 className="text-gray-900 xl:text-sm text-xs font-semibold">
                        {stage.stage}
                      </h3>
                    </div>
                    <div className="relative h-40 rotate-180 bg-transparent overflow-hidden">
                      <div
                        className={`h-full ${
                          index === 0
                            ? "bg-[#19BFB7]"
                            : index === 1
                            ? "bg-[#17ACA5]"
                            : index === 2
                            ? "bg-[#149992]"
                            : index === 3
                            ? "bg-[#138F89]"
                            : index === 4
                            ? "bg-[#0F736E]"
                            : ""
                        } rounded-lg`}
                        style={{ height: `${stage.percentage}%` }}
                      />
                      <span className="font-medium absolute top-1 -translate-x-1/2 left-1/2 rotate-180 text-white">
                        {stage.count.toLocaleString()}
                      </span>
                    </div>

                    <div className="text-xs flex gap-3 flex-col text-gray-500 mt-1">
                      <h4>Dropout ratio</h4>
                      <div className="flex items-center gap-1 text-green-600 font-semibold">
                        <span className="text-gray-900">{stage.dropout_ratio || 0}%</span>
                        <span>↑ 8.6%</span>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
            <div className="h-96 flex flex-col gap-6 py-4 px-5 border rounded-xl border-gray-200 bg-white">
              {dropDiverseData.map((item, index) => (
                <div className="flex flex-col gap-2" key={index}>
                  <h3 className="text-gray-800 font-semibold text-sm">
                    {item.title}
                  </h3>
                  {item.present && (
                    <div className="flex items-center gap-2">
                      <p className="text-gray-800 text-3xl font-semibold">
                        {item.present} %
                      </p>
                      <span
                        className={`text-sm font-medium ${
                          item.average >= 0 ? "text-green-600" : "text-red-500"
                        }`}
                      >
                        {item.average >= 0 ? "↑" : "↓"} 8.6%
                      </span>
                      <span className="text-gray-500 text-xs font-medium">
                        vs last {item.days}
                      </span>
                    </div>
                  )}
                  {item.dropOffStage && (
                    <p className="text-gray-800 text-3xl font-semibold">
                      {item.dropOffStage}
                    </p>
                  )}
                  {item.AIinsight && (
                    <p className="text-gray-800 text-sm font-semibold">
                      {item.AIinsight}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Shortlisted Resumes */}
      <div className="bg-white rounded-xl border border-gray-200 mt-10">
        <div className="bg-gray-50 py-3 px-5 rounded-t-xl">
          <h3 className="text-lg font-semibold text-gray-900">Shortlisted Resumes</h3>
        </div>
        <div className="flex gap-3 items-end py-4 px-5 border-y border-gray-200 rounded-t-md">
          <h3 className="text-2xl text-gray-900 font-semibold">120</h3>
          <div className="flex items-center gap-1 text-sm text-emerald-600">
            <span>↑ 8.6%</span>
            <span className="text-gray-600 ml-1">vs last 30 days</span>
          </div>
        </div>

        <div className="">
          <div className="px-5 py-3 grid md:grid-cols-7 grid-cols-6 border-b border-gray-200">
            <div className="flex gap-3 items-center md:col-span-3 col-span-3">
              <input
                type="checkbox"
                className="rounded border-gray-300 text-sm"
              />
              <h5 className="text-gray-500 font-semibold">candidate</h5>
            </div>

            <div className="grid grid-cols-4 md:col-span-4 col-span-3">
              <h5 className="text-gray-500 font-semibold text-sm">
                Position Applied
              </h5>
              <h5 className="text-gray-500 font-semibold text-sm">
                Experience
              </h5>
              <h5 className="text-gray-500 font-semibold text-sm">AI Score</h5>
              <h5 className="text-gray-500 font-semibold text-sm">Status</h5>
            </div>
          </div>

          {scheduledInterviews.map((interview) => (
            <div
              key={interview.id}
              className="grid md:grid-cols-7 grid-cols-6 items-center p-4 border-b border-gray-200"
            >
              <div className="md:col-span-3 col-span-3">
                <div className="flex items-center gap-3">
                  <input type="checkbox" className="rounded border-gray-300" />
                  <img
                    src={interview.avatar}
                    alt=""
                    className="w-10 h-10 rounded-full"
                  />
                  <div>
                    <p className="font-medium text-gray-900">{interview.name}</p>
                    <p className="text-sm text-gray-500">{interview.email}</p>
                  </div>
                </div>
              </div>
              <div className="w-full flex items-center justify-between md:gap-0 gap-4 sm:mr-3 md:col-span-4 col-span-3">
                <div className="grid grid-cols-4 w-full">
                  <p className="font-medium text-sm text-gray-500">
                    {interview.position}
                  </p>
                  <p className="font-medium text-sm text-gray-500">
                    {interview.experience}
                  </p>
                  <p className="font-medium text-sm text-gray-500">
                    {interview.score}
                  </p>
                  <div className="flex items-center gap-2">
                    <span className="font-medium text-center md:text-[12px] text-[10px] bg-green-100 border border-green-400 text-green-600 border md:py-2 py-1 md:px-3 px-2 rounded-md">
                      {interview.status}
                    </span>
                    <p className="text-[#009C97] cursor-pointer text-[15px] font-medium">
                      View
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}

          <div className="px-5 py-4 flex items-center justify-between bg-gray-50 rounded-b-xl">
            <div>
              <p className="text-md font-semibold text-gray-900">
                Page <span>1</span> of <span>4</span>
              </p>
            </div>
            <div className="flex gap-5 items-center">
              <button className="text-sm text-gray-900 py-2 px-3 rounded-md cursor-pointer">
                Previous
              </button>
              <button className="text-sm text-gray-900 py-2 px-3 rounded-md cursor-pointer">
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManagerDashboard;